import React, { createContext, useContext, useRef, useMemo } from "react";

type PauseAllVideosFn = () => void;
type RegisterPauseFn = (pauseFn: () => void) => () => void;

const VideoPlaybackContext = createContext<{
    pauseAllVideos: PauseAllVideosFn;
    registerPause: RegisterPauseFn;
}>({
    pauseAllVideos: () => {},
    registerPause: () => () => {},
});

export const useVideoPlayback = () => useContext(VideoPlaybackContext);

export const VideoPlaybackProvider: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const videoRefs = useRef<Set<() => void>>(new Set());

    const registerPause: RegisterPauseFn = (pauseFn) => {
        videoRefs.current.add(pauseFn);
        return () => videoRefs.current.delete(pauseFn);
    };

    const pauseAllVideos: PauseAllVideosFn = () => {
        videoRefs.current.forEach((fn) => fn());
    };

    const value = useMemo(() => ({ pauseAllVideos, registerPause }), []);

    return (
        <VideoPlaybackContext.Provider value={value}>
            {children}
        </VideoPlaybackContext.Provider>
    );
};
